// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeEntryGetBody = {
  poolId: string;
  entryId: string;
};

export type typeEntryGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    entryId: string;
    label: string;
    ownerUserId: string;
    status: "in" | "eliminated" | "revived";
    livesRemaining: number;
    livesTotal: number;
    skipsRemaining?: number | null;
    usedTeamIds: { teamId: string; lockedUntil?: string | null }[];
    pointsTotal: number;
    medalsThisContest: number;
    eliminatedAtRoundId?: string | null;
    revivesUsedThisContest: number;
    revivesUsedThisSeason: number;
  };
};

export type typeEntryGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEntryGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEntryGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaEntryGetBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    entryId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "entryId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createEntryGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaEntryGetBody);
  }

  return async function postEntryGet(
    payload: typeEntryGetBody,
  ): Promise<typeEntryGetOutput200 | typeEntryGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postEntryGet" failed before calling the network. #223baabb63a5`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#223baabb63a5" },
        },
        data: null,
      } as typeEntryGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/entry/get`,
      httpMethod: "POST",
      options,
    })) as typeEntryGetOutput200 | typeEntryGetOutput400;
  };
}
